// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__K2ZdB","success":"style_success__108it","icon":"style_icon__I6bxW"};